export default "__VITE_ASSET__BKCd59Gd__"